"use strict";
import configStore from "../../stores/configStore";
import createClasses from "../createClasses";
import _ from "lodash";
import L from "../../leaflet";
import getHashtagFromNode from "../drawerHelper";
import getArrowIcon from "../geoIcons";
const fallback = (node) => {
  var _a, _b, _c;
  let { i18n, images, locale, defaultLocale, filters } = configStore.getState();
  defaultLocale = ((_a = node == null ? void 0 : node.extendedData) == null ? void 0 : _a.defaultLocale) || defaultLocale;
  const hasImage = !_.isEmpty(node.imageUrl);
  const listCard = L.DomUtil.create("li", "decidimGeo__drawer__listCard");
  defaultLocale = ((_b = node == null ? void 0 : node.extendedData) == null ? void 0 : _b.defaultLocale) || defaultLocale;
  const GeoEncodedIcon = L.DomUtil.create(
    "img",
    createClasses("decidimGeo__drawer__listCardIcon"),
    listCard
  );
  GeoEncodedIcon.src = images == null ? void 0 : images.geolocated;
  if (!node.lonlat) {
    GeoEncodedIcon.style.opacity = "0.32";
  }
  const info = L.DomUtil.create(
    "div",
    createClasses("decidimGeo__drawer__listCardInfo", [!hasImage && "large"]),
    listCard
  );
  const infoType = L.DomUtil.create("div", "decidimGeo__drawer__listCardType", info);
  const infoTxt = L.DomUtil.create(
    "span",
    createClasses("decidimGeo__drawer__listCardTxt"),
    infoType
  );
  infoTxt.textContent = i18n[node.resourceType];
  const infoTitle = L.DomUtil.create("div", "decidimGeo__drawer__listCardTitle", info);
  const infoTitleTxt = L.DomUtil.create(
    "span",
    createClasses("decidimGeo__drawer__listTitleTxt"),
    infoTitle
  );
  infoTitleTxt.textContent = getHashtagFromNode(node, locale, defaultLocale);
  const hasAssemblyOrProcess = filters == null ? void 0 : filters.some(
    (f) => f.assembly_filter || f.process_filter
  );
  if (((_c = node == null ? void 0 : node.extendedData) == null ? void 0 : _c.componentUrl) && !hasAssemblyOrProcess) {
    const infoChild = L.DomUtil.create(
      "div",
      createClasses("decidimGeo__drawer__listCardChild"),
      infoTitle
    );
    infoChild.innerHTML += getArrowIcon();
  } else {
    const infoChild = L.DomUtil.create(
      "div",
      createClasses("decidimGeo__drawer__listCardTitle"),
      infoTitle
    );
  }
  if (node.shortDescription) {
    const text = node.shortDescription[locale] || node.shortDescription[defaultLocale] || Object.values(node.shortDescription)[0];
    if (text && !text.includes("Translation missing")) {
      const infoDescription = L.DomUtil.create(
        "div",
        "decidimGeo__drawer__listCardDescription",
        info
      );
      infoDescription.textContent = text;
    }
  }
  if (hasImage) {
    const image = L.DomUtil.create("img", "decidimGeo__drawer__listCardImg", listCard);
    image.src = node.imageUrl;
  }
  return listCard;
};
export default fallback;
